import React, { useEffect, useRef, useState } from 'react'
import Range from '../../components/Range'
import useRange from '../../hooks/range.hook'
import useAdminApi from '../../API/admin.api'
import styles from '../../styles/pages/statistic.module.css'
import useChart from '../../hooks/chart.hook'
import { getDate } from '../../utils/time.utils'


function Snapshot() {
    const adminApi = useAdminApi()
    const range = useRange(getDate(new Date(Date.now())))

    const [type, setType] = useState('Day') 
    const [triger, setTriger] = useState(false)
    const [statistic, setStatistic] = useState(null)


    const canvasCommission = useRef()
    const canvasRealizedPNL = useRef()
    const canvasDeltaCommision = useRef()
    const canvasPracticProfit = useRef()

    const commission = useChart(canvasCommission, 'line')
    const realizedPNL = useChart(canvasRealizedPNL, 'bar')
    const deltaCommision = useChart(canvasDeltaCommision, 'line') 
    const practicProfit = useChart(canvasPracticProfit, 'bar')


    const setTypeHandler = (type) => {
        setType(type)

        let startDate = ''

        if(type === 'Day') { startDate = getDate(new Date(Date.now())) }
        if(type === 'Weak') { startDate = getDate(new Date(Date.now() - 1000 * 60 * 60 * 24 * 6)) }
        if(type === 'Month') { startDate = getDate(new Date(Date.now() - 1000 * 60 * 60 * 24 * 30)) }
        
        range.setValue(startDate)

        setTriger((prew) => !prew)
    }

    const loadStatistic = async (costumLoad=true) => { 
        if(costumLoad) { setType('Custom') }

        const { start, stop } = range.value 
        const res = await adminApi.snapshots(start, stop) //
        setStatistic({
            data: res,
            info: {
                realizedCommissionDepositUah: res.reduce((acc, item) => acc + (item.realizedCommissionDepositUah || 0), 0),
                realizedCommissionPaymentUah: res.reduce((acc, item) => acc + (item.realizedCommissionPaymentUah || 0), 0),
                realizedPNL: res.reduce((acc, item) => acc + (item.realizedPNL || 0), 0),
                practicProfit: res.reduce((acc, item) => acc + (item.practicProfit || 0), 0),
                teoryProfit: res.reduce((acc, item) => acc + (item.teoryProfit || 0), 0),
                deltaAirCommision: res.reduce((acc, item) => acc + (item.deltaAirCommision || 0), 0),
            }
        })    

        const getLabel = (item) => {
            const date = new Date(item.timestamp)
            return `${date.getDate()}/${date.getMonth()+1} ${date.getHours()}:00`
        }

        commission.setData(res.map(getLabel), [ 
            { 
                label: "Realize Deposit Commision", 
                data: res.map((item) => item.realizedCommissionDepositUah) 
            },
            { 
                label: "Realize Payment Commision", 
                data: res.map((item) => item.realizedCommissionPaymentUah) 
            }
        ])
        realizedPNL.setData(res.map(getLabel), [ 
            { 
                label: "Realized PNL", 
                data: res.map((item) => item.realizedPNL) 
            }
        ])
        deltaCommision.setData(res.map(getLabel), [ 
            { 
                label: "Delta Air Commision", 
                data: res.map((item) => item.deltaAirCommision) 
            },
            { 
                label: "Teory Profit", 
                data: res.map((item) => item.teoryProfit) 
            }
        ])
        practicProfit.setData(res.map(getLabel), [ 
            { 
                label: "Practic Profit", 
                data: res.map((item) => item.practicProfit) 
            }
        ])
    } 

    useEffect(() => { loadStatistic(false).then() }, [triger])

    return (
        <div className='w-100'>
            <h2>Statistics</h2>
            <br />
            <div className='d-flex'>
                <Range range={range.bind} />
                <button className='button' onClick={() => loadStatistic()}>Load</button>
            </div>

            <div className={styles.switch}>
                <div className={`${styles.button} ${type === 'Month'? styles.active : null}`} onClick={() => setTypeHandler('Month')}>Month</div>
                <div className={`${styles.button} ${type === 'Weak'? styles.active : null}`} onClick={() => setTypeHandler('Weak')}>Weak</div>
                <div className={`${styles.button} ${type === 'Day'? styles.active : null}`} onClick={() => setTypeHandler('Day')}>Day</div>
            </div>

            <div className={styles.main}>
                <div className={styles.info}>
                    <div>
                        <h3>Snapshot</h3>
                        <div><b>Realized Commission Deposit:</b> {statistic?.info?.realizedCommissionDepositUah?.toFixed(2)} UAH</div>
                        <div><b>Realized Commission Payment:</b> {statistic?.info?.realizedCommissionPaymentUah?.toFixed(2)} UAH</div>
                        <div><b>Realized PNL:</b> {statistic?.info?.realizedPNL?.toFixed(2)} UAH</div>
                        <div><b>Delta Air Commision:</b> {statistic?.info?.deltaAirCommision?.toFixed(2)} UAH</div>
                        <div><b>Teory Profit:</b> {statistic?.info?.teoryProfit?.toFixed(2)} UAH</div>
                        <div><b>Practic Profit:</b> {statistic?.info?.practicProfit?.toFixed(2)} UAH</div>
                    </div>
                </div>
                <div className={styles.flex}>
                    <div className={styles.view}>
                        <canvas id="canvasCommissionDepositUah" ref={canvasCommission}></canvas>
                        <canvas id="canvasRealizedPNL" ref={canvasRealizedPNL}></canvas>
                        <canvas id="canvasDeltaCommision" ref={canvasDeltaCommision}></canvas>
                        <canvas id="canvasPracticProfit" ref={canvasPracticProfit}></canvas>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Snapshot